import { useEffect } from 'react'

export const REMEMBERED_PATH_KEY = 'remembered-path'

export const useRememberPath = (path?: string) => {
  useEffect(() => {
    if (path) localStorage.setItem(REMEMBERED_PATH_KEY, path)
  }, [path])

  const rememberedPath = localStorage.getItem(REMEMBERED_PATH_KEY) || '/'

  return rememberedPath
}
